/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'

const Link = React.forwardRef(
  ({ href, activeClassName, activeStyle, partiallyActive, replace, state, ...props }, ref) => {
    if (isLocalLink(href)) {
      return (
        <GatsbyLink
          to={href}
          activeClassName={activeClassName}
          activeStyle={activeStyle}
          partiallyActive={partiallyActive}
          replace={replace}
          state={state}
          {...props}
          ref={ref}
        />
      )
    }
    return <a href={href} {...props} ref={ref} />
  }
)

Link.displayName = 'Link'
Link.propTypes = {
  href: PropTypes.string.isRequired,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  partiallyActive: PropTypes.bool,
  replace: PropTypes.bool,
  state: PropTypes.object,
}

export { Link }

// This is how gatsby checks for local vs external links. We want to detect this
// and use plain anchor tags for external paths.
// https://github.com/gatsbyjs/gatsby/blob/936c74ea7ff9965c993541bd8feea82e40c0919b/packages/gatsby-link/src/index.js#L42
function isLocalLink(path) {
  return !!(
    path &&
    typeof path === 'string' &&
    !path.startsWith(`http://`) &&
    !path.startsWith(`https://`) &&
    !path.startsWith(`//`)
  )
}
